import React from 'react'
import { Box, Typography } from '@mui/material'

interface LogoProps {
  variant?: 'light' | 'dark' | 'color'
  size?: 'small' | 'medium' | 'large' | 'header'
  showText?: boolean
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'color', 
  size = 'medium', 
  showText = true 
}) => {
  const logoSizes = {
    small: { width: 32, height: 32 },
    medium: { width: 48, height: 48 },
    large: { width: 64, height: 64 },
    header: { width: 40, height: 40 }
  }
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          ...logoSizes[size],
          backgroundColor: variant === 'light' ? '#ffffff' : '#2196f3',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: variant === 'light' ? '#2196f3' : '#ffffff',
          fontWeight: 'bold',
          fontSize: size === 'small' ? '12px' : size === 'header' ? '16px' : '20px'
        }}
      >
        DE
      </Box>
      {showText && (
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 600,
            color: variant === 'light' ? '#ffffff' : '#000000',
            fontSize: size === 'small' ? '14px' : size === 'header' ? '18px' : '20px'
          }}
        >
          Dhanshika Exports
        </Typography>
      )}
    </Box>
  )
}

export default Logo